import { render, staticRenderFns } from "./PasswordRecoverySuccess.vue?vue&type=template&id=92e71fbc&"
import script from "./PasswordRecoverySuccess.vue?vue&type=script&lang=js&"
export * from "./PasswordRecoverySuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports